// Español (España) language pack
export default {
  __meta: { code: 'es-ES', label: 'Español', short: 'ES' },

  common: {
    yes: 'Sí',
    no: 'No',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    submit: 'Enviar',
    loading: 'Cargando…',
    retry: 'Reintentar',
    back: 'Atrás',
    next: 'Siguiente',
    prev: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    all: 'Todos',
    more: 'Más',
    less: 'Menos',
    close: 'Cerrar',
    edit: 'Editar',
    delete: 'Eliminar',
    copy: 'Copiar',
    share: 'Compartir',
    minutesAgo: 'hace {n} min',
    hoursAgo: 'hace {n}h',
    daysAgo: 'hace {n}d',
    online: 'En línea',
    offline: 'Sin conexión'
  },

  nav: {
    home: 'Inicio',
    problems: 'Problemas',
    teams: 'Equipos',
    leaderboard: 'Clasificación',
    chain: 'Cadena',
    academy: 'Academia',
    videos: 'HP Hackathon',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    logout: 'Cerrar sesión',
    profile: 'Perfil',
    language: 'Idioma'
  },

  home: {
    title: 'Resuelve los {n} problemas más difíciles del mundo con IA',
    subtitle: 'De Riemann a superconductores a temperatura ambiente, de la consciencia a la fusión',
    desc: 'Cualquiera puede usar IA para intentarlo. Cada solución gana {reward}.',
    reward: 'puntos HPW en cadena',
    cta: 'Empezar a resolver →',
    ctaLeaderboard: 'Clasificación',
    statsProblems: 'Problemas',
    statsSolved: 'Soluciones',
    statsUsers: 'Solucionadores',
    statsRewards: 'HPW pagados',
    categories: '{n} disciplinas',
    categoriesDesc: 'Elige un campo para ver lo que la humanidad aún no ha resuelto',
    viewAll: 'Todos los problemas →',
    liveOnChain: '{txs} txs en cadena · {blocks} bloques'
  },

  problems: {
    title: 'Todos los problemas difíciles',
    subtitle: '{n} desafíos en 8 disciplinas',
    searchPlaceholder: 'Buscar problemas, etiquetas, palabras clave…',
    filterCategory: 'Categoría',
    filterStatus: 'Estado',
    statusAll: 'Todos',
    statusOpen: 'Abierto',
    statusPartial: 'Parcial',
    statusSolved: 'Resuelto',
    difficulty: 'Dificultad',
    reward: 'Recompensa',
    solutions: 'Soluciones',
    votes: 'Votos netos',
    tags: 'Etiquetas',
    year: 'Año',
    proposer: 'Proponente',
    empty: 'No hay problemas que coincidan con tu búsqueda'
  },

  problem: {
    back: '← Volver a problemas',
    info: 'Información',
    kidExplain: 'Explicación para niños',
    formalStatement: 'Declaración formal',
    whyHard: 'Por qué es difícil',
    howToEarn: 'Cómo ganar puntos',
    earnSubmit: 'Enviar cualquier solución: +{n} HPW',
    earnAi: 'Puntuación IA ≥ {n}: +{m} HPW por punto',
    earnVote: 'Votos positivos (cada uno): +{n} HPW al autor',
    earnFullSolve: 'Resolver completo: hasta {n} HPW',
    earnRule: 'Todos los puntos se auto-apuestan en 5s. Permanentes en cadena.',
    aiSolver: 'Asistente IA',
    aiSolverDesc: 'Dile a la IA tu ángulo. Responderá en 3 capas: popular → académico → dirección de investigación.',
    aiUsingLLM: 'usando LLM real',
    aiFallback: 'respaldo heurístico',
    userInputPlaceholder: '(opcional) ¿ej. explicar con un ejemplo?',
    runAi: 'Preguntar a la IA',
    noSolution: 'Aún no hay soluciones. ¡Sé el primero!',
    submitSolution: 'Enviar solución',
    submittedBy: 'por {user}',
    quality: 'Puntuación IA',
    selfTest: 'Mi solución',
    openChat: 'Abrir asistente IA',
    inputPlaceholder: 'Hazle una pregunta específica a la IA…',
    continueChat: 'Continuar conversación ({n} mensajes)',
    openAI: '💬 Abrir asistente IA'
  },

  submit: {
    title: 'Mi solución',
    contentPlaceholder: 'Escribe tus ideas. Al menos 20 caracteres. Mejor estructura = mayor puntuación.',
    tooShort: 'Solución demasiado corta (mín. 20 caracteres)',
    submitted: '¡Enviado!',
    submitFailed: 'Error al enviar: {msg}'
  },

  leaderboard: {
    title: 'Clasificación',
    subtitle: 'Ordenado por HPW en cadena. Nuevo bloque cada 5 segundos.',
    solvers: 'Solucionadores',
    solutions: 'Soluciones totales',
    txOnChain: 'Txs en cadena',
    height: 'Altura de cadena',
    rewardsPaid: 'Recompensas pagadas',
    rank: 'Rango',
    score: 'Puntos',
    badges: 'Insignias',
    badgesTitle: '{n} niveles de insignia de challenger'
  },

  chain: {
    title: 'Explorador de blockchain',
    subtitle: 'Cada transacción de puntos está inmutablemente en cadena. Haz clic en un bloque para ver detalles.',
    height: 'Altura (bloques)',
    totalTxs: 'Txs totales',
    totalSupply: 'Suministro total (HPW)',
    valid: 'Válido',
    invalid: 'Inválido',
    selectBlock: 'Haz clic en un bloque de la izquierda para ver las transacciones',
    latestBlocks: 'Últimos bloques',
    latestTxs: 'Últimas txs',
    txId: 'ID de tx',
    type: 'Tipo',
    to: 'Para',
    amount: 'Cantidad',
    time: 'Hora',
    empty: 'Sin datos'
  },

  auth: {
    title: 'Únete a los problemas difíciles',
    subtitle: 'Crea una cuenta y empieza a resolver',
    username: 'Usuario',
    usernameHint: '2-30 caracteres, alfanuméricos, _, CJK, -',
    password: 'Contraseña',
    passwordHint: '6-200 caracteres',
    bio: 'Bio (opcional)',
    bioHint: 'máx 200 caracteres',
    register: 'Registrarse',
    login: 'Iniciar sesión',
    switchToLogin: '¿Ya tienes cuenta? Inicia sesión',
    switchToRegister: '¿No tienes cuenta? Regístrate',
    welcome: 'Bono de bienvenida de 100 HPW',
    errUsername: 'El usuario debe tener 2-30 caracteres',
    errPassword: 'La contraseña debe tener 6-200 caracteres',
    errTaken: 'Usuario en uso',
    errWrong: 'Usuario o contraseña incorrectos'
  },

  // Collaboration (v1.4.0)
  collab: {
    discussions: 'Discusiones',
    roadmap: 'Hoja de ruta',
    teams: 'Equipos',
    teamsSubtitle: 'Forma equipos con otros solucionadores. Las contribuciones se suman, las puntuaciones se comparten.',
    teamsFor: 'Equipos para este problema',
    teamsCount: 'equipo(s)',
    selectProblem: 'Selecciona un problema',
    chooseProblem: 'Elige un problema',
    pickProblemFirst: 'Elige un problema arriba para ver o crear equipos',
    startDiscussion: 'Iniciar una nueva discusión…',
    post: 'Publicar',
    reply: 'Responder',
    replyPlaceholder: 'Escribe tu respuesta…',
    upvote: 'Votar a favor',
    downvote: 'Votar en contra',
    edited: 'editado',
    noDiscussions: 'Aún no hay discusiones — ¡empieza una!',
    loginRequired: 'Por favor inicia sesión primero',
    loginToDiscuss: 'Inicia sesión para participar',
    loginToContribute: 'Inicia sesión para añadir entradas a la hoja de ruta',
    confirmDelete: '¿Seguro que quieres borrar esto? No se puede deshacer.',
    roadmapSubtitle: 'Sigue el progreso de investigación: propuesto, explorando, en curso, avance, bloqueado, hecho',
    roadmapTitlePlaceholder: 'Título del progreso',
    roadmapDescPlaceholder: 'Descripción opcional',
    addEntry: 'Añadir entrada',
    noRoadmap: 'Sin entradas en la hoja de ruta',
    createTeam: 'Crear equipo',
    teamNamePlaceholder: 'Nombre del equipo (único por problema)',
    teamDescPlaceholder: 'Descripción del equipo (opcional)',
    create: 'Crear',
    noTeamsYet: 'Aún no hay equipos',
    beFirstToCreate: '¡Sé el primero en crear uno!',
    leader: 'Líder',
    member: 'Miembro',
    members: 'miembros',
    joinTeam: 'Unirse al equipo',
    confirmLeave: '¿Salir de este equipo?',
    confirmDisband: '¿Disolver este equipo? ¡No se puede deshacer!',
    disband: 'Disolver',
    leaveTeam: 'Salir',
    contributions: 'Contribuciones',
    noContributions: 'Sin contribuciones aún',
    solutions: 'Soluciones',
    score: 'Puntos',
    teamNotFound: 'Equipo no encontrado o ya disuelto',
    backToTeams: 'Volver a equipos',
    youAreLeader: 'Eres el líder',
    youAreMember: 'Eres miembro'
  },

  notFound: {
    title: '404 — Página no encontrada',
    desc: 'La página que buscas no existe, o aún no ha sido indexada. ¿Qué tal explorar {n} problemas difíciles?',
    home: '← Inicio',
    browse: 'Explorar problemas',
    rank: 'Clasificación'
  },

  pwa: {
    install: 'Instala HardProblems en tu dispositivo para acceso rápido',
    installShort: 'Instalar',
    update: 'Nueva versión lista',
    updateNow: 'Actualizar ahora',
    offline: 'Estás sin conexión · algunas funciones no disponibles'
  },

  categories: {
    mathematics: 'Matemáticas',
    physics: 'Física',
    chemistry: 'Química',
    biology: 'Ciencias de la Vida',
    cs: 'Ciencias de la Computación',
    philosophy: 'Filosofía',
    engineering: 'Ingeniería',
    social: 'Ciencias Sociales'
  },

  // Hardcoded strings extracted from JSX
  hardcoded: {

  },

  // Hardcoded strings extracted from JSX
  hardcoded: {
    hc_87285292: 'Medalla 🎖 Challenger',
    hc_38149815: '📦 Últimos bloques',
    hc_48616739: 'Aún no hay bloques',
    hc_57878265: '📨 Últimas transacciones',
    hc_63698773: 'ID de transacción',
    hc_1714432: 'Tipo',
    hc_76617209: 'Destinatarios de cesiones',
    hc_86455028: 'Importe',
    hc_45733203: 'Tiempo',
    hc_4062857: 'Aún no hay transacciones',
    hc_15614928: 'Detalles de la operación',
    hc_12461780: 'Ninguno (bloque Génesis)',
    hc_36065070: 'Loading',
    hc_39726153: 'El usuario no existe',
    hc_65423691: 'Próxima medalla:',
    hc_65829733: 'Saldo HPW',
    hc_33844058: 'Número de respuestas',
    hc_34880504: 'Transacciones en cadena',
    hc_64546944: 'Ganado acumulado',
    hc_63635099: 'Dirección del monedero 🔑 blockchain',
    hc_92114295: 'Resolver',
    hc_12374108: 'Grabación 📨 en cadena',
    hc_38642490: 'Aún no hay transacciones en cadena',
    hc_39272624: 'Todas las preguntas difíciles',
    hc_72504969: 'On-chain',
    hc_76554194: 'transacciones ·',
    hc_13199282: 'solucionadores de problemas',
    hc_49455724: 'Resolve',
    hc_15553251: 'Lo más difícil del mundo',
    hc_73115764: 'Pregunta',
    hc_58891330: 'De la hipótesis de Riemann a la superconductividad a temperatura ambiente, de la naturaleza de la conciencia a la fusión nuclear.',
    hc_11135829: 'Recompensas de puntos HPW en la cadena',
    hc_14271420: 'Búsqueda de número de vídeo',
    hc_93127099: '"HP Hackathon"',
    hc_95444243: '· Enciende la curiosidad durante 1 minuto todos los días · Búsqueda y seguimiento de WeChat',
    hc_48803929: 'Busca "HP Hackathon" en WeChat · 1 minuto al día para despertar la curiosidad',
    hc_4038150: 'El problema no existe',
    hc_1415707: '← Volver a la lista de preguntas',
    hc_3109735: '¿Cómo 🙋 puedo participar?',
    hc_24717615: 'No es necesario que seas un experto. Puedes ayudar con esto de cualquiera de las siguientes maneras:',
    hc_6216823: 'Preguntar a la IA',
    hc_49022408: ', o en',
    hc_72042925: 'Los 10 más pedidos',
    hc_60372142: 'Asistente de 💬 IA · Conversaciones múltiples',
    hc_98658150: 'Edición infantil',
    hc_11457022: 'Declaración estricta',
    hc_53488: '¿Por qué es difícil?',
    hc_24903028: '🌀 Pensando...',
    hc_67511018: 'El contenido basado en IA modificado y luego enviado se marcará como "asistido por IA"',
    hc_74081354: '✍️ Envía tu respuesta',
    hc_8743312: 'Evaluación de 5 dimensiones',
    hc_79230102: '¡✅ Enviado correctamente!',
    hc_9486386: 'adquirir',
    hc_10506083: 'Blockchain',
    hc_60763393: '🤝 ¿Quieres formar un equipo para obtener respuestas?',
    hc_817654: 'Página del equipo de preguntas',
    hc_91839987: 'Meta información de la 📋 pregunta',
    hc_7972472: 'Año de presentación',
    hc_4585175: 'Enviado por',
    hc_49772229: 'Dificultad',
    hc_6351505: 'Estado',
    hc_77609957: 'Recompensa base',
    hc_59943341: '💰 ¿Cómo gano puntos?',
    hc_1469249: '· Envíe cualquier respuesta:',
    hc_66284549: '· Puntuación de IA ≥ 60:',
    hc_29791639: '· Me gusta (por persona por tiempo):',
    hc_97186354: '+5 HPW al autor',
    hc_18280432: '· Resuelve el rompecabezas:',
    hc_76767612: 'Todos los puntos se enrollan automáticamente en 5 segundos y son visibles permanentemente.',
    hc_55655280: '🌟 Comparte esta pregunta difícil',
    hc_9145530: 'Ventajas:',
    hc_9755158: 'Insuficiente',
    hc_78448776: 'Asistido 🤖 por IA',
    hc_99426362: 'Asistente 💬 de IA',
    hc_40752456: 'La IA ha leído todo el contexto de esta pregunta. Empecemos a preguntar ↓',
    hc_67183189: 'La IA está pensando...',
    hc_38124998: 'Enviar',
    hc_34225746: 'Se ha producido un error',
    hc_29662853: 'Altura de la cadena',
    hc_84566882: 'Bloques',
    hc_41149725: 'LA TRANSACCION',
  }
};
